import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const { t } = useTranslation();

  const testimonials = [
    {
      id: 1,
      nameKey: 'test1_name',
      locKey: 'test1_loc',
      svcKey: 'test1_svc',
      textKey: 'test1_text',
      rating: 5,
      img: 'https://public.readdy.ai/ai/img_res/73dea35393ad5a83ee1594edcec0b8ce.jpg',
    },
    {
      id: 2,
      nameKey: 'test2_name',
      locKey: 'test2_loc',
      svcKey: 'test2_svc',
      textKey: 'test2_text',
      rating: 5,
      img: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20smiling%20middle%20aged%20american%20man%20homeowner%2C%20professional%20headshot%20style%2C%20friendly%20expression%2C%20natural%20lighting%2C%20white%20background%2C%20casual%20attire&width=200&height=200&seq=orpm-testimonial-2&orientation=squarish',
    },
    {
      id: 3,
      nameKey: 'test3_name',
      locKey: 'test3_loc',
      svcKey: 'test3_svc',
      textKey: 'test3_text',
      rating: 5,
      img: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20happy%20smiling%20hispanic%20american%20woman%20homeowner%2C%20professional%20headshot%20style%2C%20warm%20friendly%20expression%2C%20natural%20lighting%2C%20white%20background%2C%20casual%20professional%20attire&width=200&height=200&seq=orpm-testimonial-3&orientation=squarish',
    },
  ];

  return (
    <section className="py-24 bg-[#1B3A6B]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-sky-400 text-sm font-bold uppercase tracking-widest">{t('test_tag')}</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mt-3 mb-4">
            {t('test_title')}
          </h2>
          <p className="text-slate-300 text-base max-w-xl mx-auto">
            {t('test_desc')}
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {testimonials.map((tst, index) => (
            <div
              key={tst.id}
              onClick={() => setActive(index)}
              className={`rounded-2xl p-7 cursor-pointer transition-all duration-300 ${
                active === index
                  ? 'bg-sky-500 border-2 border-sky-400'
                  : 'bg-white/5 border-2 border-white/10 hover:bg-white/10'
              }`}
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: tst.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm"></i>
                  </div>
                ))}
              </div>

              {/* Quote */}
              <p className="text-white/90 text-sm leading-relaxed mb-6 line-clamp-5">
                &ldquo;{t(tst.textKey)}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                  <img src={tst.img} alt={t(tst.nameKey)} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <div className="text-white font-bold text-sm">{t(tst.nameKey)}</div>
                  <div className="text-white/60 text-xs">{t(tst.locKey)}</div>
                </div>
                <div className="ml-auto">
                  <span className="bg-white/10 text-white/70 text-xs px-2 py-1 rounded-full whitespace-nowrap">
                    {t(tst.svcKey)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setActive(index)}
              className={`rounded-full transition-all cursor-pointer ${
                active === index ? 'w-8 h-2 bg-sky-400' : 'w-2 h-2 bg-white/30 hover:bg-white/50'
              }`}
              aria-label={`Testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
